import { ReactElement } from 'react'

import { ExportMenu } from '@features/expertReports'

import { useDownloadExpertProfitAndLossExport } from '../../hooks/useDownloadExpertProfitAndLossExport'

export const ExpertProfitAndLossExportMenu = (): ReactElement => {
  const { downloadExport, isExporting } = useDownloadExpertProfitAndLossExport()

  return <ExportMenu isExporting={isExporting} onSelectFormat={downloadExport} />
}
